import { dict_operator, dict_in_operator } from "@/enum/dict/common";

// 接口未提供运算符时，按控件类型使用旧字典兜底。
const FALLBACK_OPERATOR_LIST = {
  1: dict_operator,
  2: dict_in_operator,
  6: dict_in_operator,
};

// 优先使用接口 operatorList，统一输出 { value, label }。
export function getStrategyOperatorList(row) {
  const fromApi = (row && row.operatorList) || [];
  if (fromApi.length) {
    return fromApi.map((op) => ({ value: op.code, label: op.text }));
  }
  const fallback = FALLBACK_OPERATOR_LIST[Number(row && row.elType)] || [];
  return fallback.map((op) => ({ value: op.value, label: op.name }));
}
